import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter'
import './PatentApplicationDetails.css'

export default function PatentApplicationDetails({ application, isMobile }) {
  return (
    <div className='PatentApplicationDetails'>
        <div className='container'>
          <div className='containerItem'>
            <div className='group'>
              <div className='header'>Title</div>
              <div>{application.title? capitalizeFirstLetter(application.title):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Application Number</div>
              <div>{application.applicationNumber? application.applicationNumber:'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Client</div>
              <div>{application.clientName? capitalizeFirstLetter(application.clientName):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Client ID</div>
              <div>{application.clientID? application.clientID:'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Applicants</div>
              <div>{application.applicants? capitalizeFirstLetter(application.applicants):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Inventors</div>
              <div>{application.inventors? capitalizeFirstLetter(application.inventors):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Contact</div>
              <div>{application.contact? capitalizeFirstLetter(application.contact):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Entity Status</div>
              <div>{application.entityStatus? capitalizeFirstLetter(application.entityStatus):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Country:&nbsp;</div>
              <div>{application.country? application.country.toUpperCase():'---'}</div>
            </div>
          </div>
          <div className='containerItem right'>
            <div className='groupContainer'>
              <div className='group'>
                <div className='header'>Filing Date</div>
                <div>{application.filingDate? new Date(application.filingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              
              <div className='group'>
                <div className='header'>Application Type:&nbsp;</div>
                <div>
                  {
                  application.applicationType? 
                  application.applicationType==='nonProvisional'?'Non-Provisional':capitalizeFirstLetter(application.applicationType)
                  :
                  '---'
                  }
                </div>
              </div>
              <div className='group'>
                <div className='header'>Application Status:&nbsp;</div>
                <div>
                  { application.applicationStatus?
                  application.applicationStatus === 'officeActionIssued' ? 'Office Action Issued' : application.applicationStatus === 'NOAIssued' ? 'NOA Issued' : application.applicationStatus === 'awaitingExam' ? 'Awaiting Exam' : capitalizeFirstLetter(application.applicationStatus)
                  :
                  '---'
                  }
                </div>
              </div>
              <div className='group'>
                <div className='header'>Patent Type:&nbsp;</div>
                <div>{application.patentType? capitalizeFirstLetter(application.patentType):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Patent/Pub Number:&nbsp;</div>
                <div>{application.patentNumber? application.patentNumber:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Earliest Priority Application Number:&nbsp;</div>
                <div>{application.earliestPriorityApplicationNumber? application.earliestPriorityApplicationNumber:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Last Action:&nbsp;</div>
                <div>{application.lastAction? capitalizeFirstLetter(application.lastAction):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Next Action:&nbsp;</div>
                <div>{application.nextAction? capitalizeFirstLetter(application.nextAction):'---'}</div>
              </div>
            </div>
            <div className='groupContainer me-0'>
              <div className='group'>
                <div className='header'>Next Action Due:&nbsp;</div>
                <div>{application.nextActionDueDate? new Date(application.nextActionDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Filing Firm:&nbsp;</div>
                <div>{application.filingFirm? capitalizeFirstLetter(application.filingFirm):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Firm Reference Number:&nbsp;</div>
                <div>{application.firmRefNumber? application.firmRefNumber:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Attorney:&nbsp;</div>
                <div>{application.attorney? capitalizeFirstLetter(application.attorney):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Attorney Ref Number:&nbsp;</div>
                <div>{application.attorneyRefNumber? application.attorneyRefNumber:'---'}</div>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <div className='containerItem bottomContent'>
            <div className='groupContainer'>
              <div className='group'>
                <div className='header'>Earliest Priority Date:&nbsp;</div>
                <div>{application.earliestPriorityDate? new Date(application.earliestPriorityDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Planned Filing:&nbsp;</div>
                <div>{application.plannedFilingDate? new Date(application.plannedFilingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Official Filing:&nbsp;</div>
                <div>{application.officialFilingDate? new Date(application.officialFilingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>National Entry:&nbsp;</div>
                <div>{application.nationalEntryDate? new Date(application.nationalEntryDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Publication:&nbsp;</div>
                <div>{application.publicationDate? new Date(application.publicationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Estimated First Office Action:&nbsp;</div>
                <div>{application.estimatedFirstOfficeActionDate? new Date(application.estimatedFirstOfficeActionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Official Office Action:&nbsp;</div>
                <div>{application.officialOfficeActionDate? new Date(application.officialOfficeActionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
            </div>
            <div className='groupContainer'>
              <div className='group'>
                <div className='header'>Allowance:&nbsp;</div>
                <div>{application.allowanceDate? new Date(application.allowanceDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Issue Date:&nbsp;</div>
                <div>{application.issueDate? new Date(application.issueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Request Examiner Interview:&nbsp;</div>
                <div>{application.requestExaminerInterview? capitalizeFirstLetter(application.requestExaminerInterview):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Examiner Interview:&nbsp;</div>
                <div>{application.examinerInterviewDate? new Date(application.examinerInterviewDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Filed RCE:&nbsp;</div>
                <div>{application.filedRCE? capitalizeFirstLetter(application.filedRCE):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>RCE Filed:&nbsp;</div>
                <div>{application.RCEFiledDate? new Date(application.RCEFiledDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Issue Fee Payment:&nbsp;</div>
                <div>{application.issueFeePaymentDate? new Date(application.issueFeePaymentDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
            </div>
            <div className='groupContainer start me-0'>
              <div className='group'>
                <div className='header'>Maintenance Fee Due:&nbsp;</div>
                <div>{application.maintenanceFeeDueDate? new Date(application.maintenanceFeeDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Maintenance Fees Status:&nbsp;</div>
                <div>{application.maintenanceFeeStatus? capitalizeFirstLetter(application.maintenanceFeeStatus):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Expiration:&nbsp;</div>
                <div>{application.expirationDate? new Date(application.expirationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Abandoned:&nbsp;</div>
                <div>{application.abandonedDate? new Date(application.abandonedDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>PAIR Registration:&nbsp;</div>
                <div>{application.PAIRReg? application.PAIRReg:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Notes:&nbsp;</div>
                <div className='notes'>{application.notes? application.notes:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Drive Folder Location:&nbsp;</div>
                <div>
                  {application.driveFolderLocation? 
                  <a href={application.driveFolderLocation ? application.driveFolderLocation.trim() : '#'} rel="noreferrer" target='_blank'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                    </svg>
                  </a>
                  :
                  '---'
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}
